import React from 'react';
import NavigationBar from "../Components/Navbar";
import Breadcrumb from "../Components/BreadCrumb";
import AppFooter from "../Components/Footer/Footer";

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="d-flex flex-column vh-100">
            <NavigationBar />
            <main className="container-fluid flex-grow-1 d-flex flex-column mb-2 mt-3">
                {children}
            </main>
            <AppFooter />
        </div>
    );
};

export default Layout;
